<div class="column">
  <div class="flex-row">
    <app-link *ngFor="let project of projects" [item]="project"></app-link>
  </div>
</div>

